import { AxiosInstance } from 'axios';
import { formDataInputs } from '@/tools/formdatainputs';
import {
  parceRequest,
  parceTeams,
  parcePrograms,
  parceMeeting,
  parceResult,
} from './utils';
import { MentoringPoints } from './types';

const getRequestData = (api: AxiosInstance) => ({
  getRequest: async (tutored_id: string) => {
    const { data } = await api.get(MentoringPoints.GET_REQUEST, {
      params: { tutored_id },
    });

    return { ...data, data: data.data.map(parceRequest) };
  },
});

const postRequestData = (api: AxiosInstance) => ({
  postRequest: async (payload: any) => {
    const { data } = await api.post(MentoringPoints.POST_REQUEST, {
      data: { ...payload },
    });
    return data;
  },
});

const getTeamsData = (api: AxiosInstance) => ({
  getTeams: async (tutored_id: string) => {
    const { data } = await api.get(MentoringPoints.GET_TEAMS, {
      params: { tutored_id },
    });

    return {
      ...data,
      data: data.data.map((items: any) => parceTeams(items, tutored_id)),
    };
  },
});

const getProgramsData = (api: AxiosInstance) => ({
  getPrograms: async (tutored_id: string) => {
    const { data } = await api.get(MentoringPoints.GET_PROGRAMS, {
      params: { tutored_id },
    });

    return { ...data, data: data.data.map(parcePrograms) };
  },
});

const getPopupData = (api: AxiosInstance) => ({
  getPopup: async (Id: string) => {
    // const { data } = await api.get(MentoringPoints.GET_POPUP + Id);
    return { data: [] };
  },
});

const getMeetingData = (api: AxiosInstance) => ({
  getMeeting: async (Id: string, kidId: string) => {
    const { data } = await api.get(MentoringPoints.GET_MEETING, {
      params: {
        id: Id,
        tutored_id: kidId,
      },
    });

    return { ...data, data: parceMeeting(data.data) };
  },
});

const getMeetingResult = (api: AxiosInstance) => ({
  getResult: async (Id: string) => {
    const { data } = await api.get(MentoringPoints.GET_RESULT, {
      params: {
        meeting_id: Id,
      },
    });

    return { ...data, data: parceResult(data.data) };
  },
});

const postMeetingData = (api: AxiosInstance) => ({
  postMeeting: async (payload: any) => {
    const formData = formDataInputs(payload);
    const { data } = await api.post(MentoringPoints.POST_MEETING, formData);


    return data;
  },
});

const mentoringService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getRequestData(api),
    ...postRequestData(api),
    ...getTeamsData(api),
    ...getProgramsData(api),
    ...getPopupData(api),
    ...getMeetingData(api),
    ...postMeetingData(api),
    ...getMeetingResult(api),
  };
};

export default mentoringService;



// WEBPACK FOOTER //
// ./src/services/mentoring/mentoringService.ts